module.exports = __webpack_public_path__ + "img/ring_g_s_1_0.ad4e2238.png";